module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.hideData) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('p', [_vm._v("\n                " + _vm._s(_vm.$t('RISK_FACTORS_INFO')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "app-btn app-btn-primary pull-right",
    on: {
      "click": function($event) {
        _vm.hideData = !_vm.hideData
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('CHECK_DATA')) + "\n            ")])])]) : _c('div', {
    staticClass: "data-details"
  }, [_c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q1 === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row custom-span"
  }, [_c('div', {
    staticClass: "icon-group col-xs-12 col-sm-4"
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": require("../../../assets/images/icons/ico-growth.png")
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('HEIGHT')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.userHeightString))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-group col-xs-12 col-sm-4"
  }, [_c('img', {
    staticClass: "icon-img icon-img--big",
    attrs: {
      "src": require("../../../assets/images/icons/ico-weight.png")
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('WEIGHT')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.userWeightString))])]), _vm._v(" "), _c('div', {
    staticClass: "icon-group col-xs-12 col-sm-4"
  }, [_c('img', {
    staticClass: "icon-img icon-img--big",
    attrs: {
      "src": require("../../../assets/images/icons/ico-bmi.png")
    }
  }), _vm._v(" "), _c('label', [_vm._v("BMI:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.userBMIString))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q1', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q1 === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q1 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q2 === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('ZGRUBIENIE_GUZEK')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.survey.section3.q2_1 == 'YES' || _vm.survey.section3.q2_2 == 'YES' ? _vm.$t('YES') : _vm.$t('NO')))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q2', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q2 === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q2 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q2_observe === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('DO_YOU_SEE_CHANGES_IN_BREAST')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.survey.section3.q2_1_observe == 'YES' || _vm.survey.section3.q2_2_observe == 'YES' ?
    _vm.$t('YES') :
    _vm.$t('NO')))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q2-observe', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q2_observe === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q2_observe = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q3 === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('DID_YOU_USE_OESTROGENS')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.$t(_vm.survey.section3.q3)))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q3', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q3 === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q3 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q4 === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('DO_YOU_USE_HTZ')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.$t(_vm.survey.section3.q4)))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q4', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q4 === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q4 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q5_before === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('CANCER_AMONG_FAMILY_BEFORE')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.$t(_vm.survey.section3.q5_before)))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q5', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q5_before === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q5_before = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q5_after === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('CANCER_AMONG_FAMILY_AFTER')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.$t(_vm.survey.section3.q5_after)))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q5-after', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q5_after === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q5_after = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q6 === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('BRCA_AMONG_FAMILY')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.$t(_vm.survey.section3.q6)))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q6', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q6 === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q6 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q7 === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('DO_YOU_HAVE_SCARS')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.$t(_vm.survey.section3.q7)))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q7', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q7 === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q7 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row row-flex-align-bottom"
  }, [(_vm.step3q8 === false) ? _c('div', {
    staticClass: "col-xs-12 col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('DO_YOU_HAVE_CONFIRMED_BREAST_CHANGES')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-input white-input-border disabled"
  }, [_vm._v(_vm._s(_vm.survey.section3.q8_1 == 'YES' || _vm.survey.section3.q8_2 == 'YES' ? _vm.$t('YES') : _vm.$t('NO')))])])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('survey-step3-q8', {
    attrs: {
      "single": true
    },
    on: {
      "cancel": function($event) {
        return _vm.hideEditingMode(false)
      },
      "save": function($event) {
        return _vm.hideEditingMode(true)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 text-right"
  }, [(_vm.step3q8 === false) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.step3q8 = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CHANGE')) + " "), _c('img', {
    staticClass: "arrow-img",
    attrs: {
      "src": require("../../../assets/images/arrow-red.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn-primary pull-right mt-5",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('COLLAPSE')) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6bf4e36","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/my-data/risk-factors.vue
// module id = 1247
// module chunks = 0